import { render, staticRenderFns } from "./FirmaClear.vue?vue&type=template&id=0fbd5510&"
import script from "./FirmaClear.vue?vue&type=script&lang=js&"
export * from "./FirmaClear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports